// Contract: postings index copy (GOTU-6763).
// Sources: ticket:GOTU-6763 (every string);
//          merged:TempMee/dental-portal@bba1b8a2e (status values JobPostingStatus.ts:3-8;
//          profession labels constants.js:128-145, UserProfession.js:99).
// One file, two verbatim copies — change both together:
//   TempMee/dental-portal src/components/PermanentJobsV2/ManageJobs/postingsIndexCopy.ts
//   TempMee/mobile-app    src/components/dentist/PermanentJobs/ManageScreen/postingsIndexCopy.ts

export const ALL_PROFESSIONS_LABEL = 'All Professions';

export const POST_JOB_LABEL = 'Post Job';

/** The list endpoint's `status` values — a string union so this file needs no imports. */
type TPostingStatus = 'active' | 'closed' | 'draft' | 'suspended';

/**
 * Lower-cases a profession label for use mid-sentence ("Front Desk" → "front desk"),
 * keeping acronyms intact ("Expanded Functions DA" → "expanded functions DA").
 */
const toMidSentence = (label: string): string =>
  label
    .split(' ')
    .map((word) => (word.length > 1 && word === word.toUpperCase() ? word : word.toLowerCase()))
    .join(' ');

/**
 * Empty-state title for the postings index. Returns `undefined` for a status whose
 * copy this redesign leaves unchanged, so the caller keeps today's title.
 */
export const getPostingsEmptyStateTitle = ({
  status,
  professionLabel,
}: {
  status?: TPostingStatus;
  professionLabel?: string;
}): string | undefined => {
  if (status === 'active') {
    return professionLabel
      ? `No ${toMidSentence(professionLabel)} jobs posted yet`
      : 'No jobs posted yet';
  }

  if (status === 'closed') return 'No closed jobs yet';

  return undefined;
};
